import { useEffect } from 'react'

import { LocationValue } from '@flowwai-frontend/shared/common-components'

import { BOUNDS_PADDING, MAPS_NO_DATA_LOCATION } from '../constants'
import { MapCoordinates } from '../types'
import { useMapsInstanceContext } from './useMapsInstanceContext'

interface HookArgs {
   currentGeoShape?: LocationValue
   shouldAnimate?: boolean
   addressCoordinates?: MapCoordinates | null
}

export const useFitBoundsInMap = (args: HookArgs) => {
   const { currentGeoShape, shouldAnimate, addressCoordinates } = args

   const { fitBounds } = useMapsInstanceContext()

   const fitGeoShapeInBounds = (geoShape: LocationValue): void => {
      const coordinates: MapCoordinates[] =
         geoShape.type === 'POINT'
            ? geoShape.value
               ? [geoShape.value]
               : []
            : geoShape.value ?? []

      fitBounds(coordinates, shouldAnimate)
   }

   const fitAddressCoordinatesInBounds = (
      coordinates: MapCoordinates
   ): void => {
      const boundsPaddings = [-BOUNDS_PADDING, 0, BOUNDS_PADDING]
      const extendedCoordinates: MapCoordinates[] = boundsPaddings.map(
         padding => ({
            lat: coordinates.lat + padding,
            lng: coordinates.lng + padding
         })
      )

      fitBounds(extendedCoordinates)
   }

   const fitCurrentGeoShapeInBounds = (geoShape: LocationValue): void => {
      const hasCoordinates = !!geoShape.value

      if (hasCoordinates) fitGeoShapeInBounds(geoShape)
      else if (addressCoordinates)
         fitAddressCoordinatesInBounds(addressCoordinates)
      else fitBounds([MAPS_NO_DATA_LOCATION])
   }

   useEffect(() => {
      if (currentGeoShape) fitCurrentGeoShapeInBounds(currentGeoShape)
   }, [])

   return {
      fitGeoShapeInBounds
   }
}
